/* LUNAMAR · Itera · 9-oct-2026 · colecciones: fotos con el dedo, agregar con un toque (carrito lateral
   de Prestige) y submenú que se esconde al bajar. Sin dependencias. */
(function () {
  'use strict';
  if (window.__lnmColeccion) return; window.__lnmColeccion = true;

  /* puntos de las fotos: se actualizan al deslizar */
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t.classList || !t.classList.contains('lnm-pc__track')) return;
    var i = Math.round(t.scrollLeft / (t.clientWidth || 1));
    var dots = t.parentNode.querySelectorAll('.lnm-pc__dots i');
    for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-on', k === i);
  }, true);

  document.addEventListener('click', function (e) {
    var nav = e.target.closest('[data-lnm-nav]');
    if (nav) {
      var tr = nav.parentNode.querySelector('.lnm-pc__track');
      tr.scrollBy({ left: tr.clientWidth * +nav.getAttribute('data-lnm-nav'), behavior: 'smooth' });
      return;
    }
    var b = e.target.closest('[data-lnm-add]');
    if (!b) return;
    e.preventDefault();
    agregar([{ id: +b.getAttribute('data-lnm-add'), quantity: 1 }], b);
  });

  /* el protocolo del carrito lateral de Prestige: prepara secciones, agrega, avisa con cart:change */
  function agregar(items, boton) {
    boton.classList.add('is-wait');
    var secciones = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: secciones } }));
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items, sections: secciones.join(',') }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (r) {
        return fetch('/cart.js').then(function (x) { return x.json(); }).then(function (c) {
          c.sections = r.sections || {};
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: c } }));
          boton.classList.add('is-ok'); setTimeout(function () { boton.classList.remove('is-ok'); }, 1500);
          setTimeout(function () { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); }, 1800);
        });
      })
      .catch(function () { var a = boton.closest('.lnm-pc').querySelector('.lnm-pc__t'); if (a) window.location.href = a.href; })
      .then(function () { boton.classList.remove('is-wait'); });
  }

  /* submenú: se esconde al bajar, vuelve al subir */
  var sub = document.querySelector('.lnm-sub');
  if (sub) {
    var ultimo = window.scrollY;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      sub.classList.toggle('is-oculto', y > ultimo && y > 240);
      ultimo = y;
    }, { passive: true });
    var on = sub.querySelector('.is-on');
    if (on) on.scrollIntoView({ block: 'nearest', inline: 'center' });
  }
})();

/* LUNAMAR · 3-nov-2026 · carga al bajar en colecciones.
   Las primeras N tandas (data-auto) entran solas cuando el marcador se acerca a la pantalla; después solo con el botón.
   La dirección no cambia. Al salir se guarda cuántas tandas había y el scroll; al volver con «atrás» se recargan esas
   tandas y se devuelve a la persona al mismo punto (Shopify no queda en la caché de atrás/adelante del navegador).
   El marcador se busca en cada vuelta porque Prestige reemplaza la sección al filtrar u ordenar. */
(function () {
  if (window.lnmMas) return; window.lnmMas = true;
  var cargando = false, restaurando = false, auto = 0, cargadas = 0;
  var clave = 'lnmMas:' + location.pathname + location.search;

  function marcador() { return document.querySelector('.lnm-mas'); }

  function preparar() {
    var m = marcador();
    document.documentElement.classList.toggle('lnm-con-mas', !!m);
    if (m && !m.dataset.listo) { m.dataset.listo = '1'; if (!m.dataset.encadenado) { auto = 0; cargadas = 0; } }
    return m;
  }

  function cargar(m, porBoton) {
    if (cargando || !m || !m.dataset.next) return Promise.resolve(false);
    cargando = true; m.classList.add('is-cargando');
    var url = m.dataset.next, sep = url.indexOf('?') > -1 ? '&' : '?';
    return fetch(url + sep + 'section_id=' + m.dataset.section, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var lista = document.querySelector('product-list');
        var nuevaLista = doc.querySelector('product-list');
        if (!lista || !nuevaLista) throw new Error('sin lista');
        var frag = document.createDocumentFragment();
        Array.prototype.slice.call(nuevaLista.children).forEach(function (n) { frag.appendChild(n); });
        lista.appendChild(frag);
        cargadas++; if (!porBoton) auto++;
        var sig = doc.querySelector('.lnm-mas');
        if (sig) { sig.dataset.encadenado = '1'; sig.dataset.listo = '1'; m.replaceWith(sig); }
        else { m.remove(); document.documentElement.classList.remove('lnm-con-mas'); }
        document.dispatchEvent(new CustomEvent('lnm:mas-productos'));
        return true;
      })
      .catch(function () {
        // Si falla, vuelve la paginación normal.
        document.documentElement.classList.remove('lnm-con-mas');
        if (m) m.remove();
        return false;
      })
      .then(function (ok) { cargando = false; var x = marcador(); if (x) x.classList.remove('is-cargando'); revisar(); return ok; });
  }

  function revisar() {
    if (restaurando) return;
    var m = preparar();
    if (!m || cargando) return;
    var limite = parseInt(m.dataset.auto || '0', 10);
    m.classList.toggle('is-boton', auto >= limite);
    if (auto >= limite) return;
    if (m.getBoundingClientRect().top < window.innerHeight * 2) cargar(m, false);
  }

  function restaurar() {
    var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
    var dato = null;
    try { dato = JSON.parse(sessionStorage.getItem(clave) || 'null'); } catch (e) {}
    if (nav.type !== 'back_forward' || !dato || !dato.n) { revisar(); return; }
    restaurando = true;
    var objetivo = dato.n, autoGuardado = dato.a || 0;
    (function paso() {
      var m = preparar();
      if (cargadas >= objetivo || !m) {
        restaurando = false; auto = autoGuardado;
        window.scrollTo(0, dato.y || 0);
        revisar(); return;
      }
      cargando = false;
      cargar(m, true).then(function (ok) { if (ok) paso(); else { restaurando = false; window.scrollTo(0, dato.y || 0); } });
    })();
  }

  window.addEventListener('pagehide', function () {
    try { sessionStorage.setItem(clave, JSON.stringify({ n: cargadas, a: auto, y: Math.round(window.scrollY) })); } catch (e) {}
  });

  var pendiente = false;
  window.addEventListener('scroll', function () {
    if (pendiente) return; pendiente = true;
    requestAnimationFrame(function () { pendiente = false; revisar(); });
  }, { passive: true });

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.lnm-mas__b'); if (!b) return;
    e.preventDefault(); cargar(b.closest('.lnm-mas'), true);
  });

  // Prestige vuelve a pintar la sección al filtrar u ordenar: el marcador nuevo llega sin «listo» y reinicia el conteo.
  new MutationObserver(function () { if (!restaurando) preparar(); }).observe(document.body, { childList: true, subtree: true });

  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restaurar); else restaurar();
})();
